import Signup from '@/components/Signup'
import SignupContinue from '@/components/SignupContinue'
import Signin from '@/components/Signin'
import Upc from '@/components/Upc'
import Warehouse from '@/components/Warehouse'
// import Package from '@/components/Package'
import InventoryTenant from '@/components/InventoryTenant'
import InventoryUser from '@/components/InventoryUser'
import InventoryWarehouse from '@/components/InventoryWarehouse'
// import Organization from '@/components/Organization'
import Permissions from '@/components/Permissions'
import PermissionsTenant from '@/components/PermissionsTenant'
// import Task from '@/components/Task'
// import Offer from '@/components/Offer'
import Profile from '@/components/Profile'
import Member from '@/components/Member'
import ToEveryone from '@/components/ToEveryone'
// import OutBoundHistory from '@/components/OutBoundHistory'
// import PaymentUser from '@/components/PaymentUser'
// import PaymentTenant from '@/components/PaymentTenant'
import GeneralSettings from '@/components/GeneralSettings'
import WarehouseGeneralSettings from '@/components/WarehouseGeneralSettings'
import TenantUploadPackage from '@/components/TenantUploadPackage'
import WarehouseSite from '@/components/WarehouseSite'
import WarehouseAudit from '@/components/WarehouseAudit'
import WarehouseStow from '@/components/WarehouseStow'
import Administrator from '@/components/Administrator'
import BillingSettings from '@/components/BillingSettings'
import Shipping from '@/components/Shipping'
import PromotionSettings from '@/components/PromotionSettings'
import AnnouncementSettings from '@/components/AnnouncementSettings'
import StoreSettings from '@/components/StoreSettings'
import UserSettings from '@/components/UserSettings'
import PackageReportTenant from '@/components/PackageReportTenant'
// import PackageReportWarehouse from '@/components/PackageReportWarehouse'
import ProductTransferTenant from '@/components/ProductTransferTenant'
import ProductTransferWarehouse from '@/components/ProductTransferWarehouse'
import Support from '@/components/Support'
import MonthEndClose from '@/components/MonthEndClose'
import TenantOrder from '@/components/TenantOrder'
import Label from '@/components/Label'
import LabelAdmin from '@/components/LabelAdmin'
import BillingAdmin from '@/components/BillingAdmin'
import ChainRechargeRequests from '@/components/ChainRechargeRequests'
import PermissionAdmin from '@/components/PermissionAdmin'
import Prescan from '@/components/Prescan'
import Eei from '@/components/Eei'
import EeiAdmin from '@/components/EeiAdmin'
import ImportService from '@/components/ImportService'
import OP950Documents from '@/components/OP950Documents'
import HazmatAuthorizationSites from '@/components/HazmatAuthorizationSites'
import ProofDeliveryHistory from '@/components/ProofDeliveryHistory'
import Statistics from '@/components/Statistics'
import AbnormalStatistics from '@/components/AbnormalStatistics'
import {getDefinedConditionalRoutesWithEnv} from '@/utils/tools'
import ForecastPackage from '@/components/ForecastPackage'
import ReturnPackages from '@/components/ReturnPackages'
import SystemTransaction from '@/components/SystemTransaction'
import SalesSettings from '@/components/SalesSettings'
import CommonCommoditySettings from '@/components/CommonCommoditySettings'
import TrackingOTP from '@/components/TrackingOTP'
import AppleOrders from '@/components/AppleOrders'
import LabelMapping from '@/components/LabelMapping'
import WeChatBilling from '@/components/WeChatBilling'
import ImportResource from '@/components/ImportResource.vue'
const routes = {
  inbound: {
    path: '/inbound',
    component: () =>
        import(
          /* webpackChunkName: "Package" */ '@/components/Inbound'
        ),
    meta: {
      auth: [
        'warehouseOwner',
        'warehouseOperator'
      ],
      displayName: 'Inbound',
      module: ['label', 'shipment']
    }
  },
  forecastInbound: {
    path: '/forecastInbound',
    component: () =>
        import(
          /* webpackChunkName: "Package" */ '@/components/ForecastInbound'
        ),
    meta: {
      auth: [
        'warehouseOwner',
        'warehouseOperator'
      ],
      displayName: 'ForecastInbound'
    }
  },
  dropshippingInbound: {
    path: '/dropshippingInbound',
    component: () =>
        import(
          /* webpackChunkName: "Package" */ '@/components/DropshippingInbound'
        ),
    meta: {
      auth: [
        'warehouseOwner',
        'warehouseOperator'
      ],
      displayName: 'DropshippingInbound'
    }
  },
  upc: {
    path: '/upc',
    component: Upc,
    meta: {
      auth: [
        'warehouseOwner',
        'warehouseSetting'
      ],
      displayName: 'Setting/UPC'
    }
  },
  package: {
    path: '/package',
    // component: Package
    component: () =>
        import(
          /* webpackChunkName: "Package" */ '@/components/Package'
        ),
    props: (route) => ({ selectedTab: route.query.tab }),
    meta: {
      auth: [
        'warehouseOwner',
        'warehouseInventoryViewer',
        'warehouseInventoryAdmin',
        'orgOwner',
        'orgLogisticOperator',
        'orgLogisticAdmin'
      ],
      displayName: 'Package',
      module: ['label', 'shipment']
    }
  },
  Sorting: {
    path: '/Sorting',
    component: () =>
      import(
        /* webpackChunkName: "Package" */ '@/components/SortingView'
      ),
    meta: {
      auth: [
        'warehouseOwner',
        'warehouseInventoryViewer',
        'warehouseInventoryAdmin'
      ],
      displayName: 'Package',
      module: ['label', 'shipment']
    }
  },
  boxes: {
    path: '/boxes',
    // component: boxes
    component: () =>
        import(
          /* webpackChunkName: "Package" */ '@/components/BoxesView'
        ),
    props: (route) => ({ selectedTab: route.query.tab }),
    meta: {
      auth: [
        'warehouseOwner',
        'warehouseInventoryViewer',
        'warehouseInventoryAdmin',
        'orgOwner',
        'orgLogisticOperator',
        'orgLogisticAdmin'
      ],
      displayName: 'Package',
      module: ['label', 'shipment']
    }
  },
  orgBoxes: {
    path: '/orgBoxes',
    // component: boxes
    component: () =>
        import(
          /* webpackChunkName: "Package" */ '@/components/BoxesView'
        ),
    props: (route) => ({ selectedTab: route.query.tab }),
    meta: {
      auth: [
        'warehouseOwner',
        'warehouseInventoryViewer',
        'warehouseInventoryAdmin',
        'orgOwner',
        'orgLogisticOperator',
        'orgLogisticAdmin'
      ],
      displayName: 'Package',
      module: ['label', 'shipment']
    }
  },
  inventoryTenant: {
    path: '/inventoryTenant',
    component: InventoryTenant,
    meta: {
      auth: [
        'orgOwner',
        'orgLogisticAdmin',
        'orgLogisticOperator'
      ],
      displayName: 'Warehouse/Inventory'
    }
  },
  productWarehouse: {
    path: '/productWarehouse',
    component: () =>
      import(
        /* webpackChunkName: "ProductWarehouse" */ '@/components/ProductWarehouse'
      ),
    meta: {
      auth: [
        'warehouseOwner',
        'warehouseInventoryViewer',
        'warehouseInventoryAdmin'
      ],
      displayName: 'Setting/OrganizationProduct'
    }
  },
  inventoryUser: {
    path: '/inventoryUser',
    component: InventoryUser,
    meta: {
      auth: [
        'user'
      ],
      displayName: 'Inventory',
      module: ['offerAndTask']
    }
  },
  inventoryWarehouse: {
    path: '/inventoryWarehouse',
    component: InventoryWarehouse,
    meta: {
      auth: [
        'warehouseOwner',
        'warehouseInventoryViewer',
        'warehouseInventoryAdmin'
      ],
      displayName: 'Inventory'
    }
  },
  billingWarehouse: {
    path: '/billingWarehouse',
    component: () => import('@/components/BillingClient'),
    meta: {
      auth: [
        'warehouseOwner',
        'warehouseBillingAdmin'
      ],
      displayName: 'Billing'
    }
  },
  billingClient: {
    path: '/billingClient',
    component: () => import('@/components/BillingClient'),
    meta: {
      auth: [
        'orgOwner',
        'orgLabel',
        'orgBilling'
      ],
      displayName: 'Billing'
    }
  },
  warehouse: {
    path: '/warehouse',
    component: Warehouse,
    meta: {
      auth: [
        'warehouseOwner',
        'warehouseSetting'
      ],
      displayName: 'Warehouse/Site'
    }
  },
  organization: {
    path: '/organization',
    component: () =>
        import(
          /* webpackChunkName: "setting" */ '@/components/Organization'
        ),
    meta: {
      auth: [
        'warehouseOwner',
        'warehouseOrgAdmin'
      ],
      displayName: 'Setting/Organization'
    }
  },
  permissions: {
    path: '/permissions',
    component: Permissions,
    meta: {
      auth: [
        'warehouseOwner',
        'warehouseStaff'
      ],
      displayName: 'Setting/Staff'
    }
  },
  permissionsTenant: {
    path: '/permissionsTenant',
    component: PermissionsTenant,
    meta: {
      auth: [
        'orgOwner',
        'orgStaff'
        // 'orgLabel'
      ],
      displayName: 'Setting/Staff'
    }
  },
  offer: {
    path: '/offer',
    // component: Offer
    component: () =>
        import(
          /* webpackChunkName: "Package" */ '@/components/Offer'
        ),
    meta: {
      auth: [
        'orgOwner',
        'orgLogisticAdmin',
        'orgLogisticOperator',
        'user'
      ],
      displayName: 'Offer',
      module: ['offerAndTask']
    }
  },
  task: {
    path: '/task',
    // component: Task
    component: () =>
        import(
          /* webpackChunkName: "OutBoundHistory" */ '@/components/Task'
        ),
    meta: {
      auth: [
        'orgOwner',
        'orgLogisticAdmin',
        'orgLogisticOperator',
        'user'
      ],
      displayName: 'Task',
      module: ['offerAndTask']
    }
  },
  member: {
    path: '/member',
    component: Member,
    meta: {
      auth: [
        'orgOwner',
        'orgLogisticAdmin'
      ],
      displayName: 'Setting/Member',
      module: ['offerAndTask']
    }
  },
  toEveryone: {
    path: '/toEveryone',
    component: ToEveryone,
    meta: {
      auth: [
        'orgOwner',
        'orgLogisticAdmin',
        'orgLogisticOperator',
        'user',
        'warehouseOwner',
        'warehouseOperator'
      ],
      displayName: 'Outbound/Create',
      module: ['label', 'shipment']
    }
  },
  toEveryoneWithParam: {
    path: '/toEveryone/initDraft',
    component: ToEveryone,
    props: (route) => {
      return {
        initDraft: route.query
      }
    },
    meta: {
      auth: [
        'orgOwner',
        'orgLogisticAdmin',
        'orgLogisticOperator',
        'user',
        'warehouseOwner',
        'warehouseOperator'
      ],
      displayName: 'Outbound/Create',
      module: ['label', 'shipment']
    }
  },
  outBoundHistory: {
    path: '/outBoundHistory',
    // component: OutBoundHistory
    component: () =>
        import(
          /* webpackChunkName: "OutBoundHistory" */ '@/components/OutBoundHistory'
        ),
    meta: {
      auth: [
        'orgOwner',
        'orgLogisticAdmin',
        'orgLogisticOperator',
        'user',
        'warehouseOwner',
        'warehouseOperator'
      ],
      displayName: 'Outbound/Status'
    }
  },
  paymentUser: {
    path: '/paymentUser',
    // component: PaymentUser
    component: () =>
        import(
          /* webpackChunkName: "OutBoundHistory" */ '@/components/PaymentUser'
        ),
    meta: {
      auth: [
        'user'
      ],
      displayName: 'Payment',
      module: ['offerAndTask']
    }
  },
  paymentTenant: {
    path: '/paymentTenant',
    // component: PaymentTenant
    component: () =>
        import(
          /* webpackChunkName: "OutBoundHistory" */ '@/components/PaymentTenant'
        ),
    meta: {
      auth: [
        'orgOwner',
        'orgPayment'
      ],
      displayName: 'Payment',
      module: ['offerAndTask']
    }
  },
  generalSettings: {
    path: '/generalSettings',
    component: GeneralSettings,
    meta: {
      auth: [
        'orgOwner',
        'orgLabel',
        'orgGeneralSetting'
      ],
      displayName: 'Setting/General'
    }
  },
  warehouseGeneralSettings: {
    path: '/warehouseGeneralSettings',
    component: WarehouseGeneralSettings,
    meta: {
      auth: [
        'warehouseOwner',
        'warehouseSetting'
      ],
      displayName: 'Setting/General'
    }
  },
  WarehouseSite: {
    path: '/WarehouseSite',
    component: WarehouseSite,
    meta: {
      auth: [
        'orgOwner',
        'orgLogisticAdmin'
      ],
      displayName: 'Setting/Site'
    }
  },
  WarehousePacking: {
    path: '/WarehousePacking',
    component: () => import('@/components/WarehousePacking'),
    meta: {
      auth: [
        'warehouseOwner',
        'warehouseInventoryAdmin',
        'warehouseInventoryViewer',
        'warehouseOperator',
        'warehouseSupport',
        'warehouseReport'
      ],
      displayName: 'WarehousePacking',
      module: ['label', 'shipment']
    }
  },
  WarehouseAudit: {
    path: '/warehouseAudit',
    component: WarehouseAudit,
    meta: {
      auth: [
        'warehouseOwner',
        'warehouseOrgAdmin'
      ],
      displayName: 'Tools/Audit'
    }
  },
  tenantUploadPackage: {
    path: '/tenantUploadPackage',
    component: TenantUploadPackage,
    meta: {
      auth: [
        'orgOwner',
        'orgLogisticOperator'
      ],
      displayName: 'Warehouse/Upload packages'
    }
  },
  administrator: {
    path: '/administrator',
    component: Administrator,
    meta: {
      auth: [
        'sysAdmin',
        'sysAdminStaff',
        'sysAdminOverseaOperator'
      ],
      displayName: 'Registration'
    }
  },
  shippingSettings: {
    path: '/shippingSettings',
    component: Shipping,
    meta: {
      auth: [
        'orgOwner',
        'orgLogisticAdmin'
      ],
      displayName: 'Setting/Shipping'
    }
  },
  billingSettings: {
    path: '/billingSettings',
    component: BillingSettings,
    meta: {
      auth: [
        'warehouseOwner',
        'warehousePricing'
      ],
      displayName: 'Setting/Fee'
    }
  },
  promotionSettings: {
    path: '/promotionSettings',
    component: PromotionSettings,
    meta: {
      auth: [
        'warehouseOwner',
        'warehouseOrgAdmin'
      ],
      displayName: 'Setting/Promotion'
    }
  },
  announcementSettings: {
    path: '/announcementSettings',
    component: AnnouncementSettings,
    meta: {
      auth: [
        'warehouseOwner',
        'warehouseSetting',
        'sysAdmin',
        'sysAdminStaff',
        'sysAdminOverseaOperator',
        'orgOwner'
      ],
      displayName: 'Setting/Announcement'
    }
  },
  StoreSettings: {
    path: '/storeSettings',
    component: StoreSettings,
    meta: {
      auth: [
        'orgOwner',
        'orgLabel',
        'orgLogisticAdmin',
        'orgLogisticOperator'
      ],
      displayName: 'Setting/Store'
    }
  },
  userSettings: {
    path: '/userSettings',
    component: UserSettings,
    meta: {
      auth: [
        'sysAdmin',
        'sysAdminStaff',
        'sysAdminOverseaOperator'
      ],
      displayName: 'Setting/User'
    }
  },
  packageReportTenant: {
    path: '/packageReportTenant',
    component: PackageReportTenant,
    meta: {
      auth: [
        'orgOwner',
        'orgLogisticAdmin'
      ],
      displayName: 'Warehouse/Export'
    }
  },
  // packageReportWarehouse: {
  //   path: '/packageReportWarehouse',
  //   component: PackageReportWarehouse,
  //   meta: {
  //     auth: [
  //       'warehouseOwner',
  //       'warehouseInventoryViewer',
  //       'warehouseInventoryAdmin'
  //     ]
  //   }
  // },
  productTransferTenant: {
    path: '/productTransferTenant',
    component: ProductTransferTenant,
    meta: {
      auth: [
        'orgOwner',
        'orgLogisticAdmin',
        'orgLogisticOperator'
      ],
      displayName: 'Warehouse/Transfer'
    }
  },
  productTransferWarehouse: {
    path: '/productTransferWarehouse',
    component: ProductTransferWarehouse,
    meta: {
      auth: [
        'warehouseOwner',
        'warehouseInventoryAdmin',
        'warehouseInventoryViewer'
      ],
      displayName: 'Transfer'
    }
  },
  support: {
    path: '/support',
    component: Support,
    props: (route) => ({
      caseKey: route.query.caseKey || ''
    }),
    meta: {
      auth: [
        'orgOwner',
        'orgLabel',
        'orgLogisticAdmin',
        'orgLogisticOperator',
        'warehouseOwner',
        'warehouseSupport',
        'sysAdmin',
        'sysAdminStaff',
        'sysAdminOverseaOperator',
        'sysAdminDepartmentSale'
      ],
      displayName: 'Support'
    }
  },
  MonthEndClose: {
    path: '/monthEndClose',
    component: MonthEndClose,
    meta: {
      auth: [
        'orgOwner',
        'orgLogisticAdmin',
        'orgLogisticOperator'
      ],
      displayName: 'MonthEndClose'
    }
  },
  WarehouseStow: {
    path: '/WarehouseStow',
    component: WarehouseStow,
    meta: {
      auth: [
        'warehouseOwner',
        'warehouseInventoryAdmin',
        'warehouseInventoryViewer',
        'warehouseOperator',
        'warehouseSupport',
        'warehouseReport'
      ],
      displayName: 'WarehouseStow',
      module: ['label', 'shipment']
    }
  },
  warehouseStat: {
    path: '/warehouseStat',
    // component: Package
    component: () =>
      import(
        /* webpackChunkName: "Stat" */ '@/components/WarehouseStatistics'
      ),
    meta: {
      auth: [
        'warehouseOwner',
        'warehouseReport'
      ],
      displayName: 'Statistics'
    }
  },
  UserPackage: {
    path: '/UserPackage',
    component: () =>
        import(
          /* webpackChunkName" "User" */ '@/components/UserPackage'
        ),
    props: (route) => ({ tracking: route.query.tracking }),
    meta: {
      auth: [
        'user'
      ],
      displayName: 'Warehouse/Package'
    },
    module: ['offerAndTask']
  },
  tenantOrder: {
    path: '/tenantOrder',
    component: TenantOrder,
    meta: {
      betaFeature: 'labelAndOrder',
      auth: [
        'orgOwner',
        'orgLabel',
        'orgLogisticAdmin',
        'orgLogisticOperator'
      ],
      displayName: 'Order',
      module: ['label']
    }
  },
  label: {
    path: '/label',
    component: Label,
    meta: {
      betaFeature: 'labelAndOrder',
      auth: [
        'orgOwner',
        'orgLogisticAdmin',
        'orgLogisticOperator',
        'orgLabel'
      ],
      displayName: 'Label',
      module: ['label']
    }
  },
  labelHistory: {
    path: '/labelHistory',
    component: Label,
    meta: {
      betaFeature: 'labelAndOrder',
      auth: [
        'orgLabel'
      ],
      displayName: 'Label',
      module: ['label']
    }
  },
  labelForWarehouse: {
    path: '/labelForWarehouse',
    component: Label,
    meta: {
      betaFeature: 'labelAndOrder',
      auth: [
        'warehouseOwner',
        'warehouseOperator',
        'warehouseInventoryViewer',
        'warehouseInventoryAdmin'
      ],
      displayName: 'Label',
      module: ['label']
    }
  },
  eei: {
    path: '/eei',
    component: Eei,
    meta: {
      betaFeature: 'labelAndOrder',
      auth: [
        'warehouseOwner',
        'warehouseOperator',
        'warehouseInventoryViewer',
        'warehouseInventoryAdmin',
        'orgOwner',
        'orgLabel',
        'orgLogisticAdmin',
        'orgLogisticOperator'
      ],
      displayName: 'Label',
      module: ['label']
    }
  },
  prescan: {
    path: '/prescan',
    component: Prescan,
    meta: {
      auth: [
        'warehouseOwner',
        'warehouseOperator'
      ],
      displayName: 'Prescan',
      module: ['label', 'shipment']
    }
  },
  labelAdmin: {
    path: '/labelAdmin',
    component: LabelAdmin,
    meta: {
      auth: [
        'sysAdmin',
        'sysAdminStaff',
        'sysAdminOverseaOperator'
      ],
      displayName: 'Label Admin',
      module: ['label']
    }
  },
  importAdmin: {
    path: '/importAdmin',
    component: ImportService,
    meta: {
      auth: [
        'sysAdmin',
        'sysAdminStaff',
        'sysAdminOverseaOperator'
      ],
      displayName: 'Import Admin',
      module: ['oversea']
    }
  },
  import: {
    path: '/importService',
    component: ImportService,
    meta: {
      betaFeature: 'oversea',
      auth: [
        'orgOwner',
        'orgOverseaOperator'
      ],
      displayName: 'Import Service',
      module: ['oversea']
    }
  },
  OP950Documents: {
    path: '/op950Documents',
    component: OP950Documents,
    meta: {
      auth: [
        'sysAdmin',
        'sysAdminStaff',
        'sysAdminOverseaOperator',
        'warehouseOwner',
        'warehouseOperator'
      ],
      displayName: 'OP950Documents'
    }
  },
  proofDeliveryHistory: {
    path: '/proofDeliveryHistory',
    component: ProofDeliveryHistory,
    meta: {
      auth: [
        'sysAdmin',
        'sysAdminStaff',
        'sysAdminOverseaOperator'
      ],
      displayName: 'ProofDeliveryHistory'
    }
  },
  HazmatAuthorizationSites: {
    path: '/authorizationSites',
    component: HazmatAuthorizationSites,
    meta: {
      auth: [
        'sysAdmin',
        'sysAdminStaff',
        'sysAdminOverseaOperator'
      ],
      displayName: 'HazmatAuthorizationSites',
      module: ['label', 'shipment']
    }
  },
  eeiAdmin: {
    path: '/eeiAdmin',
    component: EeiAdmin,
    meta: {
      auth: [
        'sysAdmin',
        'sysAdminStaff',
        'sysAdminOverseaOperator'
      ],
      displayName: 'EEI Admin',
      module: ['label']
    }
  },
  billingAdmin: {
    path: '/billingAdmin',
    component: BillingAdmin,
    meta: {
      auth: [
        'sysAdmin',
        'sysAdminStaff',
        'sysAdminOverseaOperator',
        'sysAdminDepartmentSale',
        'sysAdminFinance'
      ],
      displayName: 'Billing Admin'
    }
  },
  chainRechargeRequests: {
    path: '/chainRechargeRequests',
    component: ChainRechargeRequests,
    meta: {
      auth: [
        'sysAdminFinance'
      ],
      displayName: 'USDT Recharge'
    }
  },
  permissionAdmin: {
    path: '/permissionAdmin',
    component: PermissionAdmin,
    meta: {
      auth: [
        'sysAdmin'
      ],
      displayName: 'Staff Admin'
    }
  },
  Statistics: {
    path: '/Statistics',
    component: Statistics,
    meta: {
      auth: [
        'sysAdmin',
        'sysAdminStaff',
        'sysAdminOverseaOperator'
      ],
      displayName: 'Statistics'
    }
  },
  AbnormalStatistics: {
    path: '/AbnormalStatistics',
    component: AbnormalStatistics,
    meta: {
      auth: [
        'sysAdmin',
        'sysAdminStaff',
        'sysAdminOverseaOperator'
      ],
      displayName: 'AbnormalStatistics'
    }
  },
  TrackingMonitorDashboard: {
    path: '/trackingMonitorDashboard',
    component: () => import(
      /* webpackChunkName: "TrackingMonitorDashboard" */ '@/components/TrackingMonitorDashboard'
    ),
    meta: {
      auth: [
        'orgLabel',
        'orgOwner',
        'orgStaff',
        'orgLogisticAdmin',
        'orgLogisticOperator',
        'orgBilling',
        'orgPayment',
        'orgGeneralSetting',
        'orgOverseaOperator',
        'sysAdmin',
        'sysAdminStaff',
        'sysAdminReport',
        'sysAdminOverseaOperator',
        'sysAdminDepartmentSale',
        'sysAdminFinance'
      ],
      displayName: 'TrackingMonitorDashboard'
    }
  },
  BusinessDashboard: {
    path: '/businessDashboard',
    component: () => import(
      /* webpackChunkName: "BusinessDashboard" */ '@/components/BusinessDashboard'
    ),
    meta: {
      auth: [
        'sysAdmin',
        'sysAdminReport',
        'sysAdminOverseaOperator',
        'sysAdminDepartmentSale',
        'sysAdminFinance'
      ],
      displayName: 'BusinessDashboard'
    }
  },
  TrackingMonitorList: {
    path: '/trackingMonitorList',
    component: () => import(
      /* webpackChunkName: "TrackingMonitorList" */ '@/components/TrackingMonitorList'
    ),
    props: (route) => ({
      initMonitorType: route.query.monitorType || '',
      initStartDate: route.query.startDate || route.query.boundaryDate || '',
      initEndDate: route.query.endDate || route.query.boundaryDate || '',
      initScope: route.query.scope || ''
    }),
    meta: {
      auth: [
        'orgLabel',
        'orgOwner',
        'orgStaff',
        'orgLogisticAdmin',
        'orgLogisticOperator',
        'orgBilling',
        'orgPayment',
        'orgGeneralSetting',
        'orgOverseaOperator',
        'sysAdmin',
        'sysAdminStaff',
        'sysAdminReport',
        'sysAdminOverseaOperator',
        'sysAdminDepartmentSale',
        'sysAdminFinance'
      ],
      displayName: 'TrackingMonitorList'
    }
  },
  ForecastTenant: {
    path: '/ForecastTenant',
    component: ForecastPackage,
    meta: {
      auth: [
        'orgOwner',
        'orgLogisticAdmin',
        'orgLogisticOperator'
      ],
      displayName: 'Forecast'
    }
  },
  ForecastWarehouse: {
    path: '/ForecastWarehouse',
    component: ForecastPackage,
    meta: {
      auth: [
        'warehouseOwner',
        'warehouseOperator',
        'warehouseInventoryViewer',
        'warehouseInventoryAdmin'
      ],
      displayName: 'ForecastInventory'
    }
  },
  ReturnPackages: {
    path: '/returnPackages',
    component: ReturnPackages,
    meta: {
      auth: [
        'sysAdmin',
        'sysAdminStaff',
        'orgOwner',
        'orgLogisticAdmin'
      ],
      displayName: 'ReturnPackages'
    }
  },
  SystemTransaction: {
    path: '/SystemTransaction',
    component: SystemTransaction,
    meta: {
      auth: [
        'sysAdmin',
        'sysAdminStaff',
        'sysAdminOverseaOperator'
      ],
      displayName: 'SystemTransaction'
    }
  },
  salesSettings: {
    path: '/salesSettings',
    component: SalesSettings,
    meta: {
      auth: [
        'sysAdmin',
        'sysAdminStaff'
      ],
      displayName: 'Sales Settings'
    }
  },
  commonCommoditySettings: {
    path: '/commonCommoditySettings',
    component: CommonCommoditySettings,
    meta: {
      auth: [
        'sysAdmin',
        'sysAdminStaff'
      ],
      displayName: 'Common Commodity Settings'
    }
  },
  profile: {
    path: '/profile',
    component: Profile
  },
  signup: {
    path: '/signup',
    component: Signup
  },
  signupContinue: {
    path: '/signupContinue',
    component: SignupContinue
  },
  signin: {
    path: '/signin',
    component: Signin
  },
  default: {
    path: '/',
    name: 'defaultRoute'
  },
  TrackingOTP: {
    path: '/TrackingOTP',
    component: TrackingOTP,
    meta: {
      auth: [
        'warehouseOwner',
        'warehouseInventoryAdmin',
        'warehouseInventoryViewer',
        'warehouseOperator',
        'warehouseSupport',
        'warehouseReport'
      ],
      displayName: 'Tracking OTP'
    }
  },
  ConfirmResetPassword: {
    path: '/confirmResetPassword',
    component: () => import('@/components/ConfirmResetPassword')
  },
  UserTrackingOTP: {
    path: '/UserTrackingOTP',
    component: TrackingOTP,
    meta: {
      auth: [
        'user',
        'orgOwner',
        'orgLogisticAdmin',
        'orgLogisticOperator'
      ],
      displayName: 'Tracking OTP'
    }
  },
  BatchLabel: {
    path: '/batchLabel',
    component: () => import('@/components/BatchLabel'),
    meta: {
      betaFeature: 'labelAndOrder',
      auth: [
        'warehouseOwner',
        'warehouseOperator',
        'warehouseInventoryViewer',
        'warehouseInventoryAdmin',
        'orgOwner',
        'orgLabel',
        'orgLogisticAdmin',
        'orgLogisticOperator'
      ],
      displayName: 'Batch Label',
      module: ['label']
    }
  },
  ProductRecords: {
    path: '/productRecords',
    component: () => import('@/components/InventoryRecordView'),
    meta: {
      auth: [
        'warehouseOwner',
        'warehouseInventoryAdmin',
        'warehouseInventoryViewer',
        'warehouseOperator',
        'warehouseSupport',
        'warehouseReport'
      ],
      displayName: 'Inventory Records'
    }
  },
  AppleOrders: {
    path: '/AppleOrders',
    component: AppleOrders,
    meta: {
      auth: [
        'orgOwner',
        'orgLogisticAdmin',
        'orgLogisticOperator',
        'warehouseOwner'
      ],
      displayName: 'Apple Orders'
    }
  },
  LabelMapping: {
    path: '/LabelMapping',
    component: LabelMapping,
    meta: {
      auth: [
        'warehouseOwner',
        'warehouseInventoryAdmin',
        'warehouseInventoryViewer',
        'warehouseOperator',
        'warehouseSupport',
        'warehouseReport'
      ],
      displayName: 'Label Mapping'
    }
  },
  WeChatBilling: {
    path: '/WeChatBilling',
    component: WeChatBilling,
    meta: {
      auth: [
        'orgOwner',
        'orgLogisticAdmin',
        'orgLogisticOperator',
        'sysAdmin',
        'sysAdminStaff'
      ],
      displayName: 'WeChat Billing'
    }
  },
  ExportClientTransactions: {
    path: '/ExportClientTransactions',
    component: () =>
        import(
          /* webpackChunkName: "ExportClientTransactions" */ '@/components/ExportClientTransactions'
        ),
    meta: {
      auth: [
        'orgOwner',
        'orgLabel',
        'orgLogisticAdmin',
        'orgLogisticOperator'
      ],
      displayName: 'Export Client Transactions'
    }
  },
  BatchShipment: {
    path: '/BatchShipment',
    component: () =>
        import(
          /* webpackChunkName: "BatchShipments" */ '@/components/BatchShipments'
        ),
    meta: {
      auth: [
        'orgOwner',
        'orgLogisticAdmin',
        'orgLogisticOperator'
      ],
      displayName: 'Batch Shipments'
    }
  },
  CombinedUpc: {
    path: '/CombinedUpc',
    component: () =>
        import(
          /* webpackChunkName: "CombinedUPc" */ '@/components/CombinedUpc'
        ),
    meta: {
      auth: [
        'orgOwner',
        'orgLogisticAdmin',
        'orgLogisticOperator'
      ],
      displayName: 'Combined UPC'
    }
  },
  importResource: {
    path: '/importResource',
    component: ImportResource,
    meta: {
      auth: [
        'sysAdmin',
        'sysAdminStaff',
        'sysAdminOverseaOperator',
        'warehouseOwner',
        'warehouseOperator',
        'warehouseInventoryAdmin',
        'warehouseInventoryViewer'
      ],
      displayName: ''
    }
  },
  efficiencyStatistics: {
    path: '/efficiencyStatistics',
    // component: Package
    component: () =>
      import(
        /* webpackChunkName: "Stat" */ '@/components/WarehouseStatisticsV2'
      ),
    meta: {
      auth: [
        'warehouseOwner',
        'warehouseReport',
        'sysAdmin',
        'sysAdminStaff',
        'sysAdminOverseaOperator'
      ],
      displayName: 'Statistics'
    }
  }
}

export default getDefinedConditionalRoutesWithEnv(routes, process.env.NODE_ENV)



// WEBPACK FOOTER //
// ./src/router/routeDefinition.js